import { b as convert } from './chunk-eb9c5778.js';



export default convert;



//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/rtl-css-js/dist/esm/index.js
// module id = 576
// module chunks = 5 6